import { useRouteError } from 'react-router';
import FehlerModal from './FehlerModal';

/**
 * Fangnetz für React Router.
 *
 * Ohne dieses zeigt der Router seine eigene Seite: „Unexpected Application Error!", ein
 * minifizierter Stack und der Hinweis „💿 Hey developer 👋". Der steht dann beim Berater
 * auf dem Schirm — mitten im Kundengespräch.
 */
export function RouterFehler() {
  const error = useRouteError();
  return <FehlerModal fehler={error} quelle="router" />;
}
